import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../styles/admin/AdminHeader.css';

const AdminHeader = ({ title }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isReportsPage = location.pathname.includes('/reports');
  const isDashboardPage = location.pathname === '/admin';

  return (
    <div className="admin-header">
      <div className="admin-header-left">
        <i className="fas fa-store"></i>
        <h1>{title || 'Admin Panel'}</h1>
      </div>
      <div className="admin-header-right">
        {isReportsPage && (
          <button 
            className="header-btn dashboard-btn" 
            onClick={() => navigate('/admin')}
          >
            <i className="fas fa-tachometer-alt"></i>
            <span>Dashboard</span>
          </button>
        )}
        {isDashboardPage && (
          <button 
            className="header-btn reports-btn" 
            onClick={() => navigate('/admin/reports')}
          >
            <i className="fas fa-chart-line"></i>
            <span>Reports</span>
          </button>
        )}
        <button 
          className="header-btn pos-btn" 
          onClick={() => navigate('/')}
        >
          <i className="fas fa-cash-register"></i>
          <span>Back to POS</span>
        </button>
      </div>
    </div>
  );
};

export default AdminHeader;